<template>
	<div class="basic-card" id="part_car_info">
		<car-tags :tags="carTags" theme="large" :style="{ marginBottom: '5px' }" />

		<p class="car-name" @click="showClipboard = true">
			{{ carName }}
		</p>

		<div class="car-sub-rows">
			<div class="car-sub">
				<span v-for="item in appearanceInfoArr" class="sub-item">
					{{ item }}
				</span>
				<span
					class="sub-item more"
					@click="$refs.configSheet.open()"
					v-sd-exp:VehicleDetailExpo="{
						page: '二手车车辆详情页',
						label_name: car.$$track_label_name,
						tag: car.$$track_tags,
						module_name: '车辆基本信息',
						position_rank: 2,
						position_in_rank: 1,
						position_in_number: 1,
						track_sign: 'aMall.b4307.exposure.VehicleDetailExpo'
					}"
					v-sd-clk:VehicleDetailClick="{
						page: '二手车车辆详情页',
						label_name: car.$$track_label_name,
						tag: car.$$track_tags,
						module_name: '车辆基本信息',
						button_name: '全部配置',
						position_rank: 2,
						position_in_rank: 1,
						position_in_number: 1,
						track_sign: 'aMall.b4307.click.VehicleDetailClick'
					}"
				>
					全部配置
					<nio-icon name="icon_arrows_right_2xs" />
				</span>
			</div>
		</div>

		<div class="price-row">
			<div class="price-value">¥ {{ formatCurrency(car.sell_programme.sell_price) }}</div>
			<!-- <div class="learn-more" @click="enterConfigDetail">
				了解车型
				<nio-icon name="icon_arrows_right_2xs" />
			</div> -->
		</div>
		<div class="desc-array">
			<div v-if="car.basic.is_baas">
				不含动力电池，电池租用服务费 ¥{{ car.sell_programme.battery_rent_price }} /月
				<nio-icon :size="14" @click="showBaasTip = true" name="icon_help_2xs" />
			</div>
			<div>
				{{ car.basic.is_baas ? 'BaaS' : '整车' }}新车价&nbsp;&nbsp;¥{{
					formatCurrency(car.sell_programme.msrp)
				}}
			</div>
		</div>

		<div class="basic-info-panel">
			<div>
				<p>
					{{ car.basic.first_plate_time ? formatDate(car.basic.first_plate_time * 1000) : '-' }}
				</p>
				<p>首次上牌</p>
			</div>
			<div>
				<p>
					{{ car.basic.location_city_code || '-' }}
				</p>
				<p>车辆所在地</p>
			</div>

			<div>
				<p>
					<span v-if="car.basic.mileage">{{ formatMileage(car.basic.mileage) }}</span>
					<span v-else>-</span>
				</p>
				<p>行驶里程</p>
			</div>
			<div>
				<p>{{ car.basic.battery_desc }}</p>
				<p>电池容量</p>
			</div>
		</div>

		<fellow-card v-if="!snapshot && car && car.basic" :car="car" @click="redirectToHomePage" />
		<nio-dialog
			v-model="showClipboard"
			title="已复制车辆号码"
			:description="car.basic.commodity_code"
			:cancel="null"
			:confirm="{ name: '我知道了', action: handleCopy }"
		></nio-dialog>

		<nio-sheet v-model="showBaasTip">
			<div class="baas-tip-popup" :style="{ paddingBottom: safeInsetBottom + 'px' }">
				<div class="baas-tip-popup__inner">
					<div class="popup-title">
						<span>电池租用服务</span>
						<nio-icon @click.stop="showBaasTip = false" name="icon_close_2xs" :size="16" />
					</div>
					<div class="popup-content">
						车辆不包含动力电池，每月电池租用服务费为
						{{ car.sell_programme && car.sell_programme.battery_rent_price }}
						元。
					</div>
				</div>
			</div>
		</nio-sheet>

		<Configuration :car="car" :configSnapshot="configSnapshot" ref="configSheet" />
	</div>
</template>

<script>
import CarTags, { businessTypeMapTag } from '@/components/CarTags'
import FellowCard from '@/views1/DetailPage/FellowCard'
import util from '@/util/util'
import nativeHybrid from '@/util/nativeHybrid'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import Configuration from './Configuration'

export const getCarTags = (car, isTrack) => {
	const tags = []

	const businessType = car.basic.business_type
	if (!isTrack) {
		const tag = businessTypeMapTag[businessType]
		tag && tags.push(tag)
	}

	if (car.tags && car.tags.length) {
		car.tags.forEach(({ tag_name, tag_colour }) => {
			tags.push({ label: tag_name, type: tag_colour })
		})
	}

	// 官方、车商直售：显示检测认证
	const detectReports = car.basic.detect_reports
	if ([1, 4].includes(businessType) && detectReports && detectReports.length) {
		tags.push({
			label: '检测认证',
			type: '4'
		})
	}

	return tags
}

export default {
	name: 'BasicCard',
	components: { FellowCard, CarTags, Configuration },
	props: {
		car: {
			type: Object,
			required: true
		},
		carName: {
			type: String,
			default: ''
		}
	},
	inject: ['snapshot', 'configSnapshot'],
	data() {
		return {
			showClipboard: false,
			showBaasTip: false,
			safeInsetBottom: getSafeInsetBottom()
		}
	},
	computed: {
		carTags() {
			return getCarTags(this.car)
		},
		appearanceInfoArr() {
			// const arr = []

			// if (this.colorPaint) {
			// 	arr.push(this.colorPaint + '外观')
			// }
			// if (this.car.basic.interior_color && allInteriorColors[this.car.basic.interior_color]) {
			// 	arr.push(allInteriorColors[this.car.basic.interior_color])
			// }
			// if (this.car.highlight_config) {
			// 	const highlight = this.car.highlight_config.map(one => one.value)
			// 	arr.push(...highlight)
			// }

			// return arr

			if (this.car && this.car.basic) {
				return (this.car.basic.all_configs || []).map(config => config.name)
			}
			return []
		}
	},
	methods: {
		handleCopy() {
			nativeHybrid.getCopyText(this.car.basic.commodity_code)
			this.showClipboard = false
		},
		formatMileage: util.formatMileage,
		formatCurrency: util.formatCurrency,
		formatDate: util.formatDate,
		enterConfigDetail() {
			// link.goToRoute('/config-detail', { sku_code: this.car.basic.commodity_code });
			nativeHybrid.openURL(`https://nio.cn/` + this.car.basic.model.toLowerCase())
		},
		redirectToHomePage() {
			if (this.car.basic.business_type !== 1) {
				nativeHybrid.openURL(
					util.getBaseEnvInfo().appUrl +
						`/app/homepage/page?is_nav_show=false&wv=lg&account_id=${this.car.basic.owner_account}`
				)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.basic-card {
	padding-top: 20px;

	.car-name {
		font-size: 24px;
		color: $text_primary;
		margin-bottom: 10px;
	}

	.car-sub-rows {
		margin-bottom: 8px;

		.car-sub {
			@include body_3(1.5, 400, false);

			overflow: hidden;
			color: #999dae;
			word-break: break-all;
			text-overflow: ellipsis;

			.sub-item {
				&:not(:last-child) {
					&:after {
						content: ' ';
						display: inline-block;
						height: 12px;
						border-right: 1px solid #e9ecf1;
						margin: 0 3px;
					}
				}
				&.more {
					color: #00bebe;
				}
			}
		}
	}

	.price-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 30px;
		margin-bottom: 5px;

		.price-value {
			@include subtitle_1(1.2, 400, false);
			color: $text_primary;
			font-weight: 440;
			font-family: 'Blue Sky Standard-Regular-Bold';
		}

		.learn-more {
			color: $text_tertiary;
			@include subtitle_4(1.5, 400, false);
		}
	}

	.desc-array {
		> div {
			color: $text_tertiary;
			@include body_3(1.5, 400, false);

			&:not(:last-child) {
				margin-bottom: 5px;
			}

			.nio-icon {
				margin-left: 6px;
			}
		}
	}

	.basic-info-panel {
		margin-top: 30px;
		padding: 15px 0;
		background-color: rgba(247, 247, 248, 0.6);
		display: flex;

		> * {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			position: relative;
			font-size: 12px;

			&:not(:last-child) {
				&:after {
					content: ' ';
					width: 1px;
					position: absolute;
					border-right: 1px solid $border_divider_primary;
					right: 0;
					height: 26px;
				}
			}

			> :first-child {
				@include body_2(1, 400, false);
				color: $text_primary;
				font-size: 12px;
			}

			> :last-child {
				@include body_2(1, 400, false);
				color: $text_tertiary;
				margin-top: 5px;
				font-size: 12px;
			}
		}
	}

	.location-array {
		padding-bottom: 30px;
		border-bottom: 1px solid #f4f4f4;
		> li {
			display: flex;
			justify-content: space-between;
			align-items: center;

			> :first-child {
				color: $text_tertiary;
				@include body_2(1.4, 400, false);
			}

			> :last-child {
				color: $text_primary;
				@include body_2(1.4, 400, false);
			}
		}
	}

	::v-deep {
		.baas-tip-popup {
			//position: fixed;
			//left: 0;
			//right: 0;
			//bottom: 0;
			background-color: #ffffff;

			&__inner {
				padding: 20px;
				overflow: hidden;
				color: $text_primary;

				.popup-title {
					margin-bottom: 25px;
					@include subtitle_3();
					display: flex;
					justify-content: space-between;
					align-items: center;
				}

				.popup-content {
					@include body_2(1.5, 400, false);
				}
			}
		}
	}
}
</style>
